const AGENCY_TYPE_CACHE_KEY = 'agencyTypeCache'

export function clearAgencyTypeCache() {
  localStorage.removeItem(AGENCY_TYPE_CACHE_KEY)
}

export default clearAgencyTypeCache
